export default "__VITE_ASSET__ByfioKFF__"